export default __webpack_public_path__ + "static/media/ic-no-service.93688d33.svg";